import * as React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

interface FormInfoProps {
    infoText: string;
}

const FormInfo: React.SFC<FormInfoProps> = (props) => {
    return <Grid item>
        <Typography paragraph variant="body2">{props.infoText}</Typography>
    </Grid>;
}

export default FormInfo;


// WEBPACK FOOTER //
// ./src/components/forms/FormInfo.tsx